module.exports = __webpack_public_path__ + "img/DAVID_CANNON_03-rs.50d56eed.jpg";